import PageReturnLink from 'crm-links/record/PageReturnLink';
import { AnyCrmObjectTypePropType
//@ts-expect-error JSFile
} from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import { normalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import { CrmLogger } from 'customer-data-tracking/loggers';
import PortalIdParser from 'PortalIdParser';
import { useCallback } from 'react';
import BackButtonSkeleton from '../../../../components/skeleton/BackButtonSkeleton';
import { useObjectTypeDefinition } from '../../../../hooks/useObjectTypeDefinition';
import { jsx as _jsx } from "react/jsx-runtime";
function IndexOrPageReturnLink({
  objectType
}) {
  var _objectTypeDefinition;
  const {
    objectTypeDefinition,
    loading
  } = useObjectTypeDefinition(normalizeTypeId(objectType));
  const pluralObjectName = (_objectTypeDefinition = objectTypeDefinition === null || objectTypeDefinition === void 0 ? void 0 : objectTypeDefinition.pluralForm) !== null && _objectTypeDefinition !== void 0 ? _objectTypeDefinition : '';
  const fallbackPagePath = `/contacts/${PortalIdParser.get()}/objects/${normalizeTypeId(objectType)}/restore`;
  const logBackLinkClick = useCallback(({
    path
  }) => {
    CrmLogger.log('recordInteractions', {
      action: 'navigate back from record page',
      path
    });
  }, []);
  if (loading) {
    return /*#__PURE__*/_jsx(BackButtonSkeleton, {});
  }
  return /*#__PURE__*/_jsx(PageReturnLink, {
    fallbackPageName: pluralObjectName,
    fallbackPagePath: fallbackPagePath,
    onTrackClick: logBackLinkClick
  });
}
IndexOrPageReturnLink.propTypes = {
  objectType: AnyCrmObjectTypePropType.isRequired
};
export default IndexOrPageReturnLink;